import { render, staticRenderFns } from "./UpdateDistroCenter.vue?vue&type=template&id=34f37027&scoped=true"
import script from "./UpdateDistroCenter.vue?vue&type=script&lang=js"
export * from "./UpdateDistroCenter.vue?vue&type=script&lang=js"
import style0 from "./UpdateDistroCenter.vue?vue&type=style&index=0&id=34f37027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f37027",
  null
  
)

export default component.exports